import { isEqual } from "lodash-es";
import type { IAnyObject } from "../types";

export const shallowDiff = (
  object1: IAnyObject,
  object2: IAnyObject,
): IAnyObject =>
  Object.entries(object1).reduce(
    (diff, [key, value]) =>
      isEqual(object2[key], value) ? diff : { ...diff, [key]: value },
    {},
  );
